import * as $ from "jquery";

// A note on the 'any's in this file: The plugin we use is the ace editor.
// We host it directly through github, and I can't find the types on npm.
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
export class Hack {
    private userId: number;
    private editor: any;

    public constructor(baseUrl: string, csrfToken: string, userId: number, ace: any) {
        this.userId = userId;

        // Editor
        this.editor = ace.edit('editor'); // eslint-disable-line @typescript-eslint/no-unsafe-assignment
        this.editor.setTheme('ace/theme/github');
        this.editor.getSession().setMode('ace/mode/json');
        this.editor.$blockScrolling = Infinity;
        this.editor.setValue('{\n    \n}');

        // Preset select and initialise (init across soft refreshes)
        const preset = this.jq('preset');
        preset.on('change', (evt) => this.setPreset($(evt.currentTarget)));
        preset.trigger('change');

        // Auto size the results screen
        $('#result-fit').on('click', () => {
            this.jq('result').width($('#editor').width() - 10);
            this.jq('result').height(220).height(this.jq('result')[0].scrollHeight);

            return false;
        });

        // Form submit
        $('.hack-ajax-form').on('submit', () => {
            $('.hack-ajax-form').removeClass('form-error');
            this.jq('result').val('');

            let data: JQuery.PlainObject = {};
            try {
                data = JSON.parse(this.editor.getValue() as string) as JQuery.PlainObject;
            } catch (e: any) {
                $('.hack-ajax-form').addClass('form-error');
                this.jq('result').val(`Invalid JSON data, exception:\n${e.message as string}`);
                return false;
            }
            if (this.jq('token').is(':checked')) {
                data._token = csrfToken; // eslint-disable-line no-underscore-dangle
            }

            let url = this.jq('url').val() as string;
            if (url.substring(0, 4) != 'http') {
                url = baseUrl + url;
            }

            void $.ajax({
                url: url,
                method: this.jq('method').val() as string,
                data: data,
                success: (result: string) => {
                    $('.hack-ajax-form').removeClass('form-error');
                    if (this.jq('json').is(':checked')) {
                        result = JSON.stringify(result, null, 4);
                    }
                    if (this.jq('remove_tags').is(':checked')) {
                        result = this.removeTags(result);
                    }
                    this.jq('result').val(result);
                },
                error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
                    $('.hack-ajax-form').addClass('form-error');
                    let xhrString = JSON.stringify(jqXHR, null, 4);
                    if (this.jq('remove_tags').is(':checked')) {
                        xhrString = this.removeTags(xhrString);
                        textStatus = this.removeTags(textStatus);
                        errorThrown = this.removeTags(errorThrown);
                    }
                    this.jq('result').val(`jqXHR: ${xhrString}\ntextStatus: ${textStatus}\nerror: ${errorThrown}`);
                }
            });

            return false;
        });
    }

    private setPreset(presetEl: JQuery<HTMLElement>) {
        $('.hack-ajax-form').removeClass('form-error');
        this.jq('result').val('');

        // Defaults
        this.jq('method').val('POST');
        this.jq('token').prop('checked', true);
        this.jq('json').prop('checked', true);
        this.jq('remove_tags').prop('checked', true);
        this.editor.setValue('{\n    \n}');

        // Specifics
        switch (presetEl.val()) {
            case 'empty': {
                this.jq('url').val('/');
                break;
            }

            case 'gameUpdate': {
                this.jq('url').val('/game/112358/play/update-state');
                break;
            }
            case 'gameFortify': {
                this.jq('url').val('/game/112358/play/fortify');
                this.setJson({ 'territory_from': 49, 'territory_to': 57, 'num_troops': 5 });
                break;
            }
            case 'gameJoin': {
                this.jq('url').val('/game/112358/play/join-game');
                this.setJson({ 'color': 1, 'password': '' });
                break;
            }
            case 'gameLeave': {
                this.jq('url').val('/game/112358/play/leave-game');
                break;
            }
            case 'gameSupport': {
                this.jq('url').val('/game/112358/play/ask-support');
                this.setJson({ 'type': 1 });
                break;
            }
            case 'gameInvite': {
                this.jq('url').val('/game/112358/play/send-invite');
                this.setJson({ 'username': 'Matty' });
                break;
            }
            case 'gameAbsence': {
                this.jq('url').val('/game/112358/play/enable-absence');
                break;
            }
            case 'gameSwitchTargets': {
                this.jq('url').val('/game/112358/play/switch-targets');
                break;
            }

            case 'getChat': {
                this.jq('url').val('/chat');
                this.setJson({ 'game_id': 1, 'room_id': 1, 'last_updated': '2001-01-01' });
                break;
            }
            case 'sendChat': {
                this.jq('url').val('/chat/send');
                this.setJson({ 'game_id': 1, 'room_id': 1, 'body': 'This is a manually inserted team message.' });
                break;
            }
            case 'deleteChat': {
                this.jq('url').val('/chat/86/delete');
                break;
            }
            case 'restoreChat': {
                this.jq('url').val('/chat/86/restore');
                break;
            }

            case 'postMessageReply': {
                this.jq('url').val('/messages/5');
                this.setJson({ 'body': 'This is a manually inserted message.' });
                break;
            }

            case 'notificationRemove': {
                this.jq('url').val('/notifications/remove');
                this.setJson({ 'notification_id': 1 });
                break;
            }
            case 'notificationTroll': {
                this.jq('url').val('/notifications/troll');
                this.setJson({ 'user_id': this.userId, 'body': 'PING!' });
                break;
            }

            case 'modChangeStatus': {
                this.jq('url').val('/modpanel/game/status');
                this.setJson({ 'game_id': 1, 'status': 3 });
                break;
            }
            case 'modChangeTimer': {
                this.jq('url').val('/modpanel/game/timer');
                this.setJson({ 'game_id': 1, 'time': 1336 });
                break;
            }

            case 'capPositionsCGP': {
                this.jq('url').val('/game/create/capitals/1');
                break;
            }

            case 'lobbyUpdate': {
                this.jq('url').val('/lobby/update');
                this.setJson({ 'live': 1, 'listview': 1 });
                break;
            }

            case 'debugState': {
                this.jq('method').val('GET');
                this.jq('url').val('/game/112358/debug/state');
                break;
            }
            case 'debugCards': {
                this.jq('method').val('GET');
                this.jq('url').val('/game/112358/debug/stack');
                break;
            }
            case 'debugEvents': {
                this.jq('method').val('GET');
                this.jq('url').val('/game/112358/debug/events');
                break;
            }

            case 'sendEmail': {
                this.jq('url').val('/modpanel/system/send-email');
                this.setJson({
                    'to_user_id': this.userId,
                    'subject': 'Test email',
                    'body': `Dear user ${this.userId},\n\n This is a plain text test mail.\n\n Yours, user ${this.userId}.`
                });
                break;
            }
            case 'sendPush': {
                this.jq('url').val('/modpanel/system/send-push-notification');
                this.setJson({
                    'to_user_id': this.userId,
                    'title': 'Push notification',
                    'body': 'This is a push notification sent through the hack panel.',
                    'url': 'https://dominating12.com/'
                });
                break;
            }
        }
    }

    private setJson(jsonObject: object) {
        this.editor.setValue(JSON.stringify(jsonObject, null, 4));
    }

    // A small helper function to easily select a form element given its name
    private jq(name: string): JQuery<HTMLElement> {
        return $(`.hack-ajax-form [name="${name}"]`);
    }

    // A small helper function to remove all <tags>.
    private removeTags(text: string): string {
        text = text.replace(/<head[^>]*>.*<\/head>/g, '');
        text = text.replace(/<[^>]*>/g, '');
        while (true) { // eslint-disable-line no-constant-condition
            const t = text;
            text = t.replace(/\\n\s*\\n/g, '\\n');
            if (text == t) {
                break;
            }
        }
        text = text.replace(/\\n/g, '\n');
        return text;
    }
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */
/* eslint-enable @typescript-eslint/no-unsafe-call */
